import { Box, Stack } from "@mui/material";
import { Icon } from "./Icon";
import Login from "./Login";
import { MainMenu } from "./MainMenu";
import { WorkbookName } from "./WorkbookName";

function Header() {
  return (
    <Box
      sx={{ display: "grid", gridTemplateColumns: "1fr 40fr 4fr" }}
      alignContent="center"
      className="Header"
      role="header"
    >
      <Box justifyContent="left" alignContent="center" sx={{ display: "grid" }}>
        <Icon />
      </Box>
      <Stack
        justifyContent="left"
        alignContent="center"
        sx={{ textAlign: "left" }}
      >
        <WorkbookName />
        <MainMenu />
      </Stack>
      <Box alignContent="center">
        <Login />
      </Box>
    </Box>
  );
}

export default Header;
